import React, { Component } from "react";
import styled, { css } from "styled-components";

const SelectView = styled.select`
  direction: ltr !important;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 39px;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
  font-weight: 400;
  font-size: 16px;
  font-family: Roboto, Arial, sans-serif;
  color: #4e2a81;
  padding-left: 7px;
  padding-right: 20px;
  margin: 0px;
  background-color: #fff;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAYAAAHgVPb9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEtJREFUeNpitHCL/c8ABAABxABiAAQQI5AAsUEijAABxAiTYgHxQAyAAEKWhgFGgACCK4MBJphymAoWGAMmAhBg2MxBBxi6UCyFMQCV2g4T6JPOgQAAAABJRU5ErkJggg==');
  background-position: 95% 16px;
  background-size: 9px auto;
  background-repeat: no-repeat;
  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);
  appearance: none;
  outline: none;
  :hover,
  :focus,
  :focus > option {
    cursor: pointer;
  }
  ::-ms-expand {
    display: none;
  }
  @media (max-width: 959px) {
    height: 38px;
    background-position: 97% 16px;
  }
  @media (max-width: 480px) {
    height: 32px;
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
    background-position: 97% 13px;
  }

  ${props =>
    props.desktop &&
    css`
    background-color: #fff;
    color: #4e2a81;`}
`;

const Label = styled.div`
  display: inline-block;
  width: 100%;
  padding-bottom: 6px;
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
  color: #797979;
  @media (max-width: 480px) {
    font-size: 16px;
  }

  ${props =>
    props.desktop &&
    css`
    display: none;`}
`;

class Select extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const { children, label, id, value, desktop } = this.props;

    return (
      <div>
        <Label desktop={desktop} htmlFor={id}>
          {label}:
        </Label>
        <SelectView
          desktop={desktop}
          id={id}
          placeholder={value}
          defaultValue={value}
          onChange={this.onChange}
        >
          {children}
        </SelectView>
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/OfflinePopup/Select.js